import {
    Box,
    Flex,
    Spinner,
    Text,
    Center,
    Button,
    useToast,
    Textarea,
    Divider,
} from '@chakra-ui/react';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import { MdArrowForward } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { OrderStatusOptions, OrderTypeOptions } from 'config/constant';
import Card from 'components/card/Card';

const Bullion = (props) => {
    const details = props.details;

    const taskTypeButton = [
        {
            value: 'OPEN_SAVING_PLAN',
            taskButton: (
                <Button
                    variant='light'
                    onClick={() => {
                        GoToSavingPlan(details?.info?.customer_saving_plan_id);
                    }}>
                    <Text
                        fontWeight='bold'
                        mr={2}>
                        View Connected Saving Plan
                    </Text>
                    <MdArrowForward />
                </Button>
            ),
        },
        {
            value: 'INSTALLMENT_SAVING_PLAN',
            taskButton: (
                <Button
                    variant='light'
                    onClick={() => {
                        GoToSavingPlan(details?.info?.customer_saving_plan_id);
                    }}>
                    <Text
                        fontWeight='bold'
                        mr={2}>
                        View Connected Saving Plan
                    </Text>
                    <MdArrowForward />
                </Button>
            ),
        },
    ];

    const GoToOrder = (id) => {
        // console.log(id)
        const url = `/admin/order/${id}`;
        window.open(url, '_blank');
    };

    const GoToSavingPlan = (id) => {
        // console.log(id)
        const url = `/admin/myplan/${id}`;
        window.open(url, '_blank');
    };

    const GoToCustomerUser = (id) => {
        // console.log(id)
        const url = `/admin/customeruser/${id}`;
        window.open(url, '_blank');
    };

    const GoToAdminUser = (id) => {
        // console.log(id)
        const url = `/admin/adminuser/${id}`;
        window.open(url, '_blank');
    };

    const GoToStore = (id) => {
        const url = `/admin/store/${id}`;
        window.open(url, '_blank');
    };

    return (
        <>
            <Flex
                mt={2}
                direction='column'
                gap={3}
                width='100%'>
                <Text
                    fontSize='2xl'
                    fontWeight='500'>
                    Bullion Desk Request
                </Text>
                <Card bgColor='gray.200'>
                    <Flex
                        direction={{ base: 'column', '2xl': 'row' }}
                        gap={4}>
                        <Flex
                            h='100%'
                            width='100%'
                            direction='column'
                            gap={4}
                            bgColor='gray.200'>
                            <Card
                                h='100%'
                                gap={4}
                                bgColor='gray.100'>
                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Duration</Text>
                                    <Text>{moment(details.start).format('DD MMM YY, HH:mm')} to{' '}
                                        {moment(details.expiry).format('DD MMM YY, HH:mm')}{' '}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Metal Type</Text>
                                    <Text>{details?.type}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Unit</Text>
                                    <Text>{details?.unit}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Sell Price</Text>
                                    <Text>₹ {details?.sell} /{details?.unit}</Text>
                                </Flex>


                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Sell Threshold </Text>
                                    <Text>{details?.threshold_sell} {details?.unit}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Sell Subtract</Text>
                                    <Text>₹ {details?.threshold_sell_addon}</Text>
                                </Flex>


                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Buy Price</Text>
                                    <Text>₹ {details?.buy} /{details?.unit}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Buy Threshold </Text>
                                    <Text>{details?.threshold_buy} {details?.unit}</Text>
                                </Flex>

                                <Flex
                                    justifyContent='space-between'
                                    gap={2}>
                                    <Text fontWeight='medium'>Customer Buy AddOn</Text>
                                    <Text>₹ {details?.threshold_buy_addon}</Text>
                                </Flex>


                            </Card>
                        </Flex>

                    </Flex>
                </Card>
            </Flex>
        </>
    );
};

export default Bullion;
